<template>
	<BaseCmsPage @load="onPageLoad">
		<CmsCheckoutWrapper>
			<WebshopCheckout>
				<ClientOnly>
					<BaseWebshopCart v-slot="{cart}">
						<BaseForm @submit="onSubmit" v-slot="{meta}" data-autofocus>
							<div class="wc-form wc-form-customer floating-labels-checkout" v-if="cart">
								<div class="wc-form-col1">
									<ClientOnly>
										<WebshopHelloBar />
									</ClientOnly>
									<WebshopSteps :step="1" />

									<BaseAuthUser v-slot="{isLoggedIn, user, urls}">
										<div v-if="paymentError" class="unavailable-item special">
											<div class="title">
												<template v-if="user?.user_id"><BaseCmsLabel code="error_login_use_missing_data" tag="strong" /></template>
												<template v-else>
													<template v-if="paymentError?.length">
														<template v-if="paymentError[0]?.error == 'error_address_must_contain_number' && paymentError[0]?.user_logged_in">
															<NuxtLink :to="urls.auth_edit"><BaseCmsLabel :code="paymentError[0].error" tag="strong" /></NuxtLink>
														</template>
														<BaseCmsLabel v-else :code="paymentError[0]?.error" tag="strong" />
													</template>
												</template>
											</div>
											<div class="btn-hidde" @click="hiddeErrorMessage()">
												<BaseCmsLabel code="hidde_error" tag="span" />
											</div>
										</div>

										<template v-if="user?.user_id && userError?.length">
											<div class="unavailable-item special" v-for="error in userError" :key="error.label_name">
												<div class="title"><BaseCmsLabel :code="error.label_name" tag="strong" /></div>
											</div>
										</template>

										<template v-if="cart.warnings?.cart">
											<div v-for="warning in cart.warnings.cart" :key="warning.label_name" class="unavailable-item special">
												<div class="title"><BaseCmsLabel :code="warning.label_name" tag="strong" /></div>
											</div>
										</template>
										<template v-if="cart.errors?.cart">
											<div v-for="error in cart.warnings.errors" :key="error.label_name" class="unavailable-item special">
												<div class="title"><BaseCmsLabel :code="error.label_name" /></div>
											</div>
										</template>

										<div v-if="isLoggedIn" class="wc-user-info">
											<div v-if="user?.first_name" class="name">
												{{ user.first_name }}
												<template v-if="user?.last_name"> {{ user.last_name }}</template>
												<NuxtLink :to="urls.auth_edit" class="wc-edit-profile"><BaseCmsLabel code="checkout_edit_profile" /></NuxtLink>
											</div>
											<p v-if="user?.address">
												{{ user.address }}<br />
												<template v-if="user?.zipcode">{{ user.zipcode }}&nbsp;</template>
												<template v-if="user?.city">{{ user.city }}</template>
											</p>
											<p v-if="user?.email">{{ user.email }}</p>
											<p v-if="user?.phone">{{ user.phone }}</p>
										</div>

										<div class="wc-fields form">
											<template v-for="field in customerFields" :key="field.name">
												<BaseFormField v-if="field.name != 'f_another_country' && field.type == 'checkbox' && field.opens_fields" :item="field" v-slot="{errorMessage, value, isTouched, floatingLabel}">
													<div class="box-field" :class="{'active': field.name == 'b_same_as_shipping' ? !value : value}">
														<div class="checkbox-field" :class="['input-field-'+field.name, {'field-error': errorMessage && isTouched, 'field-success': !errorMessage && value, 'floated-label': floatingLabel}]">
															<BaseFormInput />
															<label @click="clearExtraBPhoneValue(field)" :for="field.name"><BaseCmsLabel :code="field.name" /></label>
														</div>

														<template v-if="field.opens_fields[0]">
															<div class="subfields">
																<div class="subfields-title">
																	<template v-if="field.name == 'b_r1'"><BaseCmsLabel code="company_oib_subtitle" /></template>
																	<template v-if="field.name == 'b_same_as_shipping'"><BaseCmsLabel code="same_as_shipping_subtitle" /></template>
																</div>
																<div class="wc-fields">
																	<template v-for="subfield in customerFields" :key="subfield.name">
																		<BaseFormField :item="subfield" v-slot="{errorMessage, value, isTouched, floatingLabel}">
																			<BaseFormCompanyOibField v-if="subfield.related_field == field.name && subfield.name == 'b_company_oib'" :field="subfield" :fields="customerFields" />
																			<div
																				v-else-if="subfield.related_field == field.name && subfield.type != 'checkbox'"
																				class="input-field field"
																				:class="['input-field-'+subfield.name, {'field-error': errorMessage && isTouched, 'field-success': !errorMessage && value, 'floated-label': floatingLabel || subfield?.name == 'b_phone'}]">
																				<template v-if="subfield?.name == 'b_phone' && subfield?.options_prefix">
																					<WebshopWidgetPhoneCountry :field="subfield" :input="extraBPhoneValue" @phoneValueInput="phoneBValueInput" @selectCountryValue="selectBCountryValue" />
																					<BaseFormInput type="hidden" :value="subfield.value" />
																				</template>
																				<template v-else>
																					<BaseFormInput />
																				</template>
																				<label :for="subfield.name"><BaseCmsLabel :code="subfield.name" /></label>
																				<span class="error" v-show="errorMessage" v-html="errorMessage" />
																			</div>
																		</BaseFormField>
																	</template>
																</div>
															</div>
														</template>
													</div>
												</BaseFormField>
												<template v-if="!user">
													<BaseFormField v-if="field?.name == 'f_another_country' && field?.type == 'checkbox' && field?.opens_fields" :item="field" v-slot="{errorMessage, value, isTouched, floatingLabel}">
														<div class="box-another-country" :class="{'active': field.name == 'f_another_country' ? value : !value}">
															<div class="input-field-another-country" :class="['input-field-'+field.name, {'field-error': errorMessage && isTouched, 'field-success': !errorMessage && value, 'floated-label': floatingLabel}]">
																<BaseFormInput />
																<span v-if="value" class="label label-special"><BaseCmsLabel code="f_another_country_unactive" /></span>
																<div v-if="value" class="warning"><BaseCmsLabel code="f_another_country_note" /></div>
																<label @click="anotherCountryToggle(!value)" class="label" :class="{'active': value}" :for="field.name">
																	<BaseCmsLabel v-if="!value" :code='field.name + "_unactive"' />
																	<BaseCmsLabel v-else :code='field.name + "_active"' />
																</label>
															</div>
															<template v-if="field?.opens_fields[0]">
																<div class="subfields-another-country">
																	<template v-for="subfield in customerFields" :key="subfield.name">
																		<BaseFormField :item="subfield" v-slot="{errorMessage, value, isTouched, floatingLabel}">
																			<div
																				v-if="subfield.related_field == field.name && subfield.type != 'checkbox'"
																				class="input-field field"
																				:class="['input-field-'+subfield.name, {'field-error': errorMessage && isTouched, 'field-value': value, 'field-success': !errorMessage && value, 'floated-label': floatingLabel || subfield?.name == 'b_phone'}]">
																				<BaseFormInput />
																				<label :for="subfield.name"><BaseCmsLabel :code="subfield.name" /></label>
																				<span class="error" v-show="errorMessage" v-html="errorMessage" />
																			</div>
																		</BaseFormField>
																	</template>
																</div>
															</template>
														</div>
													</BaseFormField>
													<BaseFormField v-if="!field.opens_fields && !field.related_field" :item="field" v-slot="{errorMessage, value, isTouched, floatingLabel}">
														<div
															class="input-field field"
															:class="['input-field-'+field.name, {'disabled-another-country': field.name == 'address' ? anotherCountry : false || field.name == 'location' ? anotherCountry : false, 'field-error': errorMessage && isTouched, 'field-success': !errorMessage && value, 'floated-label': floatingLabel || field?.name == 'phone'}]">
															<template v-if="field?.name == 'phone' && field?.options_prefix">
																<WebshopWidgetPhoneCountry :field="field" @phoneValueInput="phoneValueInput" @selectCountryValue="selectCountryValue" />
																<BaseFormInput type="hidden" :value="field.value" />
															</template>
															<template v-else-if="anotherCountry == true && (field?.name == 'city' || field?.name == 'zipcode' || field?.name == 'address' || field?.name == 'location')">
																<div class="input-field-another-country-disabled"></div>
															</template>
															<template v-else>
																<BaseFormInput />
															</template>
															<label :for="field.name"><BaseCmsLabel :code="field.name" /></label>
															<span class="error" v-show="errorMessage" v-html="errorMessage" />
														</div>
													</BaseFormField>
												</template>
											</template>
										</div>
									</BaseAuthUser>
								</div>

								<WebshopSidebar :meta="meta" customer="true" />
								<WebshopWidgetFixedbar :meta="meta" customer="true" />
							</div>
						</BaseForm>
					</BaseWebshopCart>
					<template #fallback>
						<BaseThemeUiLoading />
					</template>
				</ClientOnly>
			</WebshopCheckout>
		</CmsCheckoutWrapper>
	</BaseCmsPage>
</template>

<script setup>
	const endpoints = useEndpoints();
	const webshop = useWebshop();
	const apiRoutes = useApiRoutes();
	const auth = useAuth();
	const cartData = computed(() => webshop.getCartData());
	const dom = useDom();
	const apiErrors = ref([]);
	const { customerFields, formSubmitCount, paymentError, checkoutLoading, formValid } = useCheckout();
	let userError = ref([]);
	const isLoggedIn = computed(() => auth.isLoggedIn());
	const gtm = useGtmBB();

	function onPageLoad(data) {
		if(!data) return;
		gtm.pageView({
			url: data?.url || '',
			title: data?.title || '',
		});
	}

	// fetch form fields
	let focusTimeout = null;
	let cartErrorTimeout = null;
	let cartWarningTimeout = null;
	let submitTimeout = null;
	onMounted(async() => {
		await nextTick();

		if(!customerFields.value?.length) {
			await useApi(`${endpoints.get('_get_hapi_customer_fields')}?type=webshop.customer&change_fields=first_name:max_length=20,last_name:max_length=30,b_first_name:max_length=20,b_last_name:max_length=30,phone:type=tel,b_phone:type=tel,b_company_oib:type=tel`)
			.then(res => {
				const fields = res.data?.length ? res.data : [];
				if(fields.length) {
					customerFields.value = fields.map(field => {
						if (field.name == 'b_location') {
							field.related_field = 'b_same_as_shipping';
						}
						return field;
					});

					// Reorder the array based on the specified condition
					const locationIndex = customerFields.value.findIndex(field => field.name === 'location');
					const countryIndex = customerFields.value.findIndex(field => field.name === 'f_another_country');

					if (locationIndex !== -1 && countryIndex !== -1) {
						const countryField = customerFields.value.splice(countryIndex, 1)[0];
						// Insert 'f_country' after 'b_location'
						customerFields.value.splice(locationIndex + 1, 0, countryField);
					}
				}
			});
		}

		const fAnotherCountryValue = (customerFields.value?.find(obj => obj.name === "f_another_country") || {}).value;
		if (fAnotherCountryValue) {
			anotherCountry.value = true;
		}

		//user phone error
		if (isLoggedIn.value && customerFields.value?.length) {
			customerFields.value.forEach(el => {
				if (el.errors != null) {
					el.errors.forEach(el2 => {
						if (el2 != null) {
							userError.value.push({'label_name': el2.label_name});
						}
					});
				}
			});
		}

		// redirect to cart page if there are errors in cart
		if (cartData.cart?.errors?.cart?.length) {
			cartErrorTimeout = setTimeout(async () => {
				await navigateTo(apiRoutes.getAppUrl('webshop_shopping_cart'));
			}, 1000);
		}

		// redirect to cart page if there are warnings in cart
		if (cartData.cart?.warnings?.cart?.length) {
			cartWarningTimeout = setTimeout(async () => {
				await navigateTo(apiRoutes.getAppUrl('webshop_shopping_cart'));
			}, 1000);
		}

		// set focus on first field in form. "data-autofocus" attribute needs to be set on form element
		focusTimeout = setTimeout(() => {
			dom.setFieldFocus();
		}, 500);

		if (userError.value.length) {
			formValid.value = 0;
		}
	});

	//phone value
	const phoneValue = ref(null);
	function phoneValueInput(combinedValue) {
		const phoneFieldIndex = customerFields.value.findIndex(field => field.name === 'phone');
		if (phoneFieldIndex !== -1) {
			customerFields.value[phoneFieldIndex].value = combinedValue;
			phoneValue.value = combinedValue
		}
	}
	function phoneBValueInput(combinedValue) {
		const phoneBFieldIndex = customerFields.value.findIndex(field => field.name === 'b_phone');
		if (phoneBFieldIndex !== -1) {
			customerFields.value[phoneBFieldIndex].value = combinedValue;
		}
	}
	function selectCountryValue(combinedValue) {
		const phoneFieldSelectIndex = customerFields.value.findIndex(field => field.name === 'phone');
		if (phoneFieldSelectIndex !== -1) {
			customerFields.value[phoneFieldSelectIndex].value = combinedValue;
		}
	}
	function selectBCountryValue(combinedValue) {
		const phoneFieldBSelectIndex = customerFields.value.findIndex(field => field.name === 'b_phone');
		if (phoneFieldBSelectIndex !== -1) {
			customerFields.value[phoneFieldBSelectIndex].value = combinedValue;
		}
	}

	//clear extra b_phone value
	const extraBPhoneValue = ref(false);
	function clearExtraBPhoneValue(item) {
		if(item?.name == 'b_same_as_shipping') {
			extraBPhoneValue.value = true;
		}
	}

	//another country active
	const anotherCountry = ref(false);
	function anotherCountryToggle(value) {
		anotherCountry.value = value;
	}

	//on submit
	async function onSubmit({values, actions}) {
		if(submitTimeout) clearTimeout(submitTimeout);
		checkoutLoading.value = true;
		let userData = (isLoggedIn.value) ? {} : values;

		if(isLoggedIn.value) {
			if(customerFields.value?.length){
				customerFields.value.forEach(el => {
					userData[el.name] = el.value;
				});

				for (const key in values) {
					const field = customerFields.value.find((field) => field.name === key);
					if (field && field.value !== values[key]) {
						userData[key] = values[key];
					}
				}
			}

			if (userData?.b_location && userData?.b_location?.trim() !== "") {
				const parts = userData.b_location.split(' ');
				userData.b_city = parts.slice(1).join(' ');
			}
		}

		if (!isLoggedIn.value && userData.location && userData.location.trim() !== "") {
			const parts = userData.location.split(' ');
			userData.city = parts.slice(1).join(' ');
		}

		if (!isLoggedIn.value && userData.b_location && userData.b_location.trim() !== "") {
			const parts = userData.b_location.split(' ');
			userData.b_city = parts.slice(1).join(' ');
		}

		if (!isLoggedIn.value && userData.f_another_country ) {
			userData.location = '';
			userData.city = '';
			userData.zipcode = '';
			userData.address = '';
			userData.f_location = userData.f_zipcode + ' ' + userData.f_city;
		}

		userData['_change_fields'] = 'first_name:max_length=20,last_name:max_length=30,b_first_name:max_length=20,b_last_name:max_length=30,phone:type=tel,b_phone:type=tel,b_company_oib:type=tel';

		await webshop.submitCustomerData(userData)
		.then(async res => {
			submitTimeout = setTimeout(async () => {
				if (res.success) {
					await webshop.setParcelDefaultShipping().then(async res => {
						await webshop.fetchCart();
						navigateTo(apiRoutes.getAppUrl('webshop_shipping'));
					});

					await useApi(`${endpoints.get('_get_hapi_customer_fields')}?type=webshop.customer&change_fields=first_name:max_length=20,last_name:max_length=30,b_first_name:max_length=20,b_last_name:max_length=30,phone:type=tel,b_phone:type=tel,b_company_oib:type=tel`)
					.then(res => {
						const fields = res.data?.length ? res.data : [];
						if(fields.length) {
							customerFields.value = fields.map(field => {
								if (field.name == 'b_location') {
									field.related_field = 'b_same_as_shipping';
								}
								return field;
							});

							// Reorder the array based on the specified condition
							const locationIndex = customerFields.value.findIndex(field => field.name === 'location');
							const countryIndex = customerFields.value.findIndex(field => field.name === 'f_another_country');

							if (locationIndex !== -1 && countryIndex !== -1) {
								const countryField = customerFields.value.splice(countryIndex, 1)[0];
								// Insert 'f_country' after 'b_location'
								customerFields.value.splice(locationIndex + 1, 0, countryField);
							}
						}
					});
					checkoutLoading.value = false;
				} else {
					paymentError.value = res.data?.errors?.length ? res.data.errors : null;
					checkoutLoading.value = false;
				}
			}, 500);
		});
	};

	//hidde error message
	function hiddeErrorMessage() {
		paymentError.value = null;
	}

	onBeforeUnmount(() => {
		clearTimeout(cartErrorTimeout);
		clearTimeout(cartWarningTimeout);
		clearTimeout(focusTimeout);
		clearTimeout(submitTimeout);
	});
</script>

<style lang="less">
	.field{position: relative;}
	.autocomplete-container{
		display: block!important; width: 100%; max-height: 250px!important; border: none!important; box-shadow: 0 5px 20px 0 rgb(0 0 0 / 15%)!important; font-size: 15px!important; position: absolute; top: 52px!important; z-index: 11111!important;
		&::-webkit-scrollbar {-webkit-appearance: none;width: 4px; background: #E0E8EE;}
		&::-webkit-scrollbar-thumb {border-radius: 0; background-color: #99AAB8; -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);}
		&::-webkit-scrollbar-track {border: 1px solid #E0E8EE;}
		.hide-cursor{caret-color: transparent;}
		li{
			padding: 6px 20px!important; border-bottom: 1px solid @borderColor!important; cursor: pointer; .transition(all);
			&:hover, &.active{background: @secondaryColor; color: #fff;}
		}
	}


	.input-field-zipcode, .input-field-city, .input-field-b_zipcode, .input-field-b_city{display: none!important;}
	.wc-user-info {
		padding: 0 0 20px 40px; font-size: 15px; position: relative;
		&:before{.icon-user(); font: 26px/26px @fonti; color: @blue; position: absolute; top: -2px; left: 0;}
		.name{padding-bottom: 5px; font-size: 17px; font-weight: 600;}
		p{padding-bottom: 5px;}
	}
	.wc-edit-profile{
		margin-left: 8px; padding-left: 9px; font-size: 15px; position: relative;
		&:before{.pseudo(1px,13px); background: @borderColor; top: 3px; left: 0;}
		&:hover{color: @blue; text-decoration: none;}
	}

	.wc-fields{
		display: flex; justify-content: space-between; flex-wrap: wrap;

		@media (max-width: @ms){display: block;}
	}
	.input-field{
		width: 49%;

		@media (max-width: @ms) {width: 100%;}
	}

	.input-field-phone, .input-field-b_phone{
		input{padding-left: 110px;}
	}

	.box-another-country{
		width: 100%; margin: -27px 0 17px;
		&.active{
			.subfields-another-country{display: flex;}
			.input-field-another-country{margin-bottom: 20px; text-align: left;}
		}

		@media (max-width: @ms){
			margin: -24px 0 15px;
			&.active{
				.subfields-another-country{display: block;}
				.input-field-another-country{display: inline-block; margin-bottom: 20px;}
			}
		}
	}
	.subfields-another-country{display: none; justify-content: space-between; flex-wrap: wrap;}
	.input-field-another-country-disabled{display: flex; align-items: center; justify-content: center; height: 54px; padding: 0 20px; background: rgba(215,228,239,0.25); pointer-events: none; border: 1px solid @borderColor;}
	.input-field-another-country{
		flex-grow: 1; text-align: right;
		input[type=checkbox]+label, .label{
			min-height: unset; padding: 0; font-size: 13px; line-height: 1; color: @blue; text-decoration: underline; text-underline-offset: 2px; cursor: pointer;
			&:before{content: none;}
			&.active{color: @red2;}
			&:hover{text-decoration: none;}
		}
		.label-special{display: block; flex-grow: 1; margin-top: 8px; text-align: right; color: #7891A9; text-decoration: none; cursor: default;}
		.warning{
			display: flex; align-items: center; margin: 10px 0 14px; padding: 17px 22px 17px 53px; border: 1px solid @red2; font-size: 14px; line-height: 19px; font-weight: bold; box-shadow: 0 10px 25px 0 rgba(120,145,169,0.15); position: relative; z-index: 1;
			&:before{.icon-warning; font: 19px/1 @fonti; color: @red2; font-weight: bold; position: absolute; top: 17px; left: 22px;}
			&:after{.pseudo(8px,8px); background: @white; border: 1px solid @red2; border-right: none; border-bottom: none; position: absolute; right: 41px; top: -5px; .rotate(45deg);}
		}

		@media (max-width: @t){
			input[type=checkbox]+label, .label{
				&:hover{text-decoration: underline;}
			}
		}
		@media (max-width: @ms){
			.label-special{margin-top: 5px;}
			.warning{
				margin: 10px 0 10px; padding: 13px 17px 13px 43px;
				&:before{font-size: 14px; top: 16px; left: 17px;}
				&:after{right: 41px; top: -5px;}
			}
		}
	}
	.input-field-f_country.field-value label{opacity: 0;}
	.disabled-another-country{
		pointer-events: none;
		&:before{content: none!important;}
		input{font-size: 0; background: rgba(215,228,239,0.25);}
		label{font-size: 16px!important; top: 16px!important;}
	}

	.box-field{
		width: 100%; min-height: 54px; margin-bottom: 20px; border: 1px solid @borderColor; .transition(border-color);
		&.active{
			border-color: @blue;
			.subfields{display: block;}
		}
		.checkbox-field{
			display: flex; align-items: center;
			label{
				display: grid; width: 100%; min-height: unset; padding: 17px 15px 17px 48px; .transition(all);
				@media (max-width: @ms){padding-top: 18px;}
				&:before{top: 16px; left: 15px;}
			}
			input[type=checkbox]:checked + label{background: #EBF4FF;}
		}
		.input-field-b_same_as_shipping{
			input[type=checkbox]:checked + label{background: @white;}
			input[type=checkbox]:checked + label:before{background: @white; border-color: @borderColor; color: @white;}

			input[type=checkbox] + label{background: #EBF4FF;}
			input[type=checkbox] + label:before{background: @blue; border-color: @blue;}
		}
	}
	.subfields{
		display: none; padding: 20px 30px 5px; border-top: 1px solid @blue;

		@media (max-width: @ms){padding: 15px 15px 5px;}
	}
	.subfields-title{font-weight: bold; padding-bottom: 7px; font-size: 15px;}
	/*------- /checkout -------*/
</style>
